import { render } from "./ButtonCancel.vue?vue&type=template&id=e39f3c62"
import script from "./ButtonCancel.vue?vue&type=script&lang=js"
export * from "./ButtonCancel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__